export const navigationItems = {
  firstLevel: [
    {
      link: "/",
      label: "Главная",
    },
    {
      link: "/users",
      label: "Пользователи",
      onlyVipRoles: true,
    },
    {
      link: "/clients",
      label: "Клиенты",
    },
    {
      link: "/providers",
      label: "Поставщики",
    },
    {
      link: "/shifts_calendars",
      label: "Календари смен",
      onlyVipRoles: true,
    },
    {
      link: "/login_history",
      label: "История входов",
      onlyVipRoles: true,
    },
    {
      link: "/achievements",
      label: "Достижения",
      onlyVipRoles: true,
    },
    {
      link: "/projects",
      label: "Проекты",
    },
    {
      link: "/purchase_orders",
      label: "Наряд-заказы",
    },
  ],
  secondLevel: [
    {
      link: "/stock_movement",
      label: "Движение по складу",
    },
    {
      link: "/inventory",
      label: "Инвентаризация",
    },
    {
      link: "/products",
      label: "Продукты",
    },
    {
      link: "/cut_of_clothes",
      label: "Крой",
    },
    {
      link: "/cloths",
      label: "Ткани",
    },
    {
      link: "/sewing_accessories",
      label: "Фурнитура",
    },
    {
      link: "/stationery",
      label: "Канцелярия",
    },
    {
      link: "/expendable_materials",
      label: "Расходники",
    },
    {
      link: "/packages",
      label: "Упаковки",
    },
    {
      link: "/promotional_products",
      label: "Рекламная продукция",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/_shared/constants/navigation.js